import type { RouteRecordRaw } from 'vue-router'

export default [
  {
    path: 'index',
    name: 'index',
    meta: { title: '首页', login: true, componentName: 'AdminIndex' },
    component: () => import('@/views/pc/AdminIndex.vue'),
    props: true
  },
  {
    path: 'operation',
    redirect: () => '/index'
  },
  {
    path: 'me',
    name: 'me',
    meta: { title: '个人中心', login: true, componentName: 'AdminMe' },
    component: () => import('@/views/pc/AdminMe.vue'),
    props: true
  }
] as RouteRecordRaw[]
